import { aboutContent } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">{aboutContent.title}</h2>
        </div>

        <div className="flex flex-col lg:flex-row gap-8 md:gap-12">
          <div className="flex-1">
            {aboutContent.paragraphs.map((p, i) => (
              <p key={i} className={`text-sm md:text-base text-foreground-600 leading-relaxed ${i > 0 ? 'mt-4' : ''}`}>
                {p}
              </p>
            ))}
            <div className="flex flex-wrap gap-3 mt-6">
              {aboutContent.highlights.map((h) => (
                <span key={h} className="px-3 py-1.5 bg-primary-100/70 text-primary-700 text-xs font-medium rounded-full">
                  {h}
                </span>
              ))}
            </div>
          </div>

          <div className="flex-1">
            <div className="relative rounded-lg overflow-hidden aspect-[16/10]">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20newsroom%20with%20multiple%20screens%20displaying%20breaking%20news%2C%20warm%20ambient%20lighting%2C%20investigative%20journalism%20atmosphere%2C%20professional%20editorial%20environment%2C%20dark%20wood%20desks%20with%20papers%20and%20documents%2C%20dramatic%20shadows%2C%20warm%20crimson%20and%20gold%20accents%2C%20intense%20focused%20mood&width=960&height=600&seq=about-visual&orientation=landscape"
                alt="51每日大赛关于我们 - 独立调查报道平台"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}